<!-- eslint-disable vue/max-attributes-per-line -->
<template>
  <div class="observable section container-wrap overflow-hidden relative" :class="[backgroundMedia ? 'flex min-h-screen' : '']" :style="{ background: !backgroundTransition ? sectionBackgroundColor.hex : 'transparent' }">
    <div v-if="backgroundMedia" class="section_background absolute top-0 bottom-0 left-0 right-0 w-100 h-100">
      <SharedVideo :url="backgroundMedia.url" />
    </div>
    <div class="container-wrap relative section_card md:grid-cols-12" :class="[contentBlend ? 'blendCard':'', !graphicImage ? 'grid grid-cols-1 gap-0' : 'md:flex']" :style="{ background: hex }">
      <div v-if="image" class="w-full col-span-12 md:col-span-6 flex justify-center" :class="[verticalSectionPadding, imageOrder, 
        graphicImage ? `
          xxl:w-[480px] xxl:h-[480px]
          xl:w-[480px] xl:h-[480px]
          lg:w-[420px] lg:h-[420px]
          md:my-[128px] md:w-[280px] md:h-[280px]
          mb-[48px] mt-[64px] mx-auto w-[280px] h-[280px]
          ` : !fullBleedImage ? `
          grid grid-cols-1 content-start content-stretch h-full
        ` : ''
        ]">
        <SharedVideo v-if="isVideo" class="w-full md:col-span-12" :url="image.url" />
        <div v-else :class="[
          graphicImage ? `
          xxl:mx-[100]
          xl:mx-[60px]
          lg:mx-[46px]
          md:mx-[52px]
          mx-auto
          ` : '',
          !graphicImage && !fullBleedImage ? `h-[100%] overflow-hidden 
          md:pt-[64px] lg:pt-[85px] xl:pt-[100px] xxl:pt-[120px]` : `pb-[100%] w-full aspect-square h-52`,
          !graphicImage && !fullBleedImage && imagePosition === 'right'? `md:pr-[64px] lg:pr-[85px] xl:pr-[100px] xxl:pr-[120px]`:``,
          !graphicImage && !fullBleedImage && imagePosition === 'left'? `md:pl-[64px] lg:pl-[85px] xl:pl-[100px] xxl:pl-[120px]`:``
        ]">
          <div class="bg-contain bg-center bg-no-repeat" :class="[
          graphicImage ? 'mx-auto w-[280px] h-[280px] lg:w-[420px] lg:h-[420px] xl:w-[480px] xl:h-[480px]' : 
          !fullBleedImage ? `
            md:bg-cover
            md:pt-auto md:h-full md:w-auto md:aspect-auto
            pt-[100%] w-[100%] aspect-square
          ` : 'pt-[100%] w-[100%] aspect-square h-52'
          ]" 
          :style="{ backgroundImage: 'url(' + useImageOptimizer(image.url) + ')' }" />
        </div>
      </div>

      <div :class="[
        image ? 'md:col-span-6 content-center' :`w-full flex md:col-span-12 md:col-start-1 m-auto`,
        graphicImage ? 'w-full md:w-1/2' : '',
        backgroundMedia ? 'items-start' : 'items-center'
      ]">
        <div class="
          md:item-center content-center
          " :class="[
            image ? `
              xxl:mx-[120px]
              xl:mx-[100px]
              lg:mx-[85px]
              md:my-[128px] md:mx-[64px]
              mt-[48px] mb-[64px] mx-[32px]` : `
              xxl:max-w-[720px]
              xl:max-w-[600px]
              lg:max-w-[510px]
              md:my-[128px]
              md:max-w-[512px]
              my-[128px]
              max-w-[326px] m-auto
              `,
            alignContent]">
          <h2 class="font-druk uppercase leading-none" :class="[list ? 'text-display-12 lg:text-display-14' : ' text-display-14 xl:text-display-20']" :style="{ color: title1Color.hex }">
            {{ getTitle1 }}
          </h2>
          <h2 v-if="title2" class="font-druk uppercase leading-none" :class="[list ? 'text-display-12 lg:text-display-14' : ' text-display-14 xl:text-display-20']" :style="{ color: title2Color.hex }">
            {{ title2 }}
          </h2>
          <div class="standard-content-text mt-8 font-light" :class="[ctaType !== 'none' ? '' : '', list ? 'text-smaller lg:text-display-5 font-light leading-[26px]' : 'text-smaller xl:text-display-5 leading-130%', alignContent]" :style="{ color: bodyColor.hex }" v-html="getBody" />
          <div v-if="ctaType !== 'none'" class="action_holder flex" :class="[alignContent]">
            <SharedArrowButton width="wrap" class="mt-8"  :background="ctaBackgroundColor.hex" :color="ctaTextColor.hex" :border="ctaOutline" :text="ctaText" @click="ctaClicked()"
            :class="[ alignContent === 'text-center items-center' ? 'mx-auto' : '']"   />
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script setup>
const route = useRoute()
const countriesStore = useCountriesStore()

const props = defineProps({
  title1: {
    type: String,
    default: ''
  },
  title1Color: {
    type: Object,
    default: () => {
      return {
        hex: '#FF3846'
      }
    }
  },
  title2: {
    type: String,
    default: null
  },
  title2Color: {
    type: Object,
    default: () => {
      return {
        hex: '#FF3846'
      }
    }
  },
  body: {
    type: String,
    default: ''
  },
  bodyColor: {
    type: Object,
    default: () => {
      return {
        hex: 'black'
      }
    }
  },
  ctaText: {
    type: String,
    default: 'Learn more'
  },
  ctaBackgroundColor: {
    type: Object,
    default: () => {
      return {
        hex: 'white'
      }
    }
  },
  ctaTextColor: {
    type: Object,
    default: () => {
      return {
        hex: 'black'
      }
    }
  },
  ctaType: {
    type: String,
    default: 'none'
  },
  ctaUrl: {
    type: String,
    default: null
  },
  ctaOutline: {
    type: Boolean,
    default: false
  },
  sectionBackgroundColor: {
    type: Object,
    default: () => {
      return {
        hex: '#F8B8CC'
      }
    }
  },
  imagePosition: {
    type: String,
    default: 'left',
    enum: ['left', 'right', 'top', 'bottom']
  },
  imagePositionMobile: {
    type: String,
    default: 'bottom',
    enum: ['top', 'bottom']
  },
  image: {
    type: Object,
    default: null
  },
  contentAlign: {
    type: String,
    default: 'center'
  },
  backgroundTransition: {
    type: Boolean,
    default: false
  },
  list: {
    type: Boolean,
    default: false
  },
  fullBleedImage: {
    type: Boolean,
    default: false
  },
  graphicImage: {
    type: Boolean,
    default: false
  },
  backgroundMedia: {
    type: Object,
    default: null
  },
  contentBlend: {
    type: Boolean,
    default: false
  }
})

const isVideo = ref(false)

if (props.image?.url?.includes('mp4')) {
  isVideo.value = true
}

const getTitle1 = computed(() => {
  if (props.title1.indexOf(/{{country}}/g) && route.params.country) {
    return props.title1.replace(/{{country}}/g, route.params.country)
  }
  return props.title1
})
const getBody = computed(() => {
  if (props.title1.indexOf(/{{country}}/g) && route.params.country) {
    return props.body.replace(/{{country}}/g, '<span class="capitalize">' + route.params.country + '</span>')
  }
  return props.body
})

const imageOrder = computed(() => {
  if (props.image) {
    if (props.imagePositionMobile === 'top' && props.imagePosition === 'right') {
      return 'order-first md:order-last'
    }
    if (props.imagePositionMobile === 'bottom' && props.imagePosition === 'right') {
      return 'order-last'
    }
    if (props.imagePositionMobile === 'top' && props.imagePosition === 'left') {
      return 'order-first'
    }
    if (props.imagePositionMobile === 'bottom' && props.imagePosition === 'left') {
      return 'order-last md:order-first'
    }

    if (props.imagePositionMobile === 'top' && props.imagePosition === 'bottom') {
      return 'order-first md:order-last'
    }
    if (props.imagePositionMobile === 'bottom' && props.imagePosition === 'bottom') {
      return 'order-last'
    }
    if (props.imagePositionMobile === 'top' && props.imagePosition === 'top') {
      return 'order-first'
    }
    if (props.imagePositionMobile === 'bottom' && props.imagePosition === 'top') {
      return 'order-last md:order-first'
    }
  }
})

const isVertical = computed(() => {
  return props.imagePosition === 'top' || props.imagePosition === 'bottom'
})

const verticalSectionPadding = computed(() => {
  if (props.imagePosition === 'top') {
    return 'pt-20'
  }
  if (props.imagePosition === 'bottom') {
    return 'pb-20'
  }
  return ''
})

const alignContent = computed(() => {
  if (props.list && !isVertical.value) {
    return 'text-left items-start'
  }
  let justify = props.contentAlign
  props.contentAlign === 'left' ? justify = 'start' : props.contentAlign === 'right' ? justify = 'end' : justify = 'center'
  const textAlign = `text-${props.contentAlign}`
  const contentAlign = `items-${justify}`
  return `${textAlign} ${contentAlign}`
})

const emit = defineEmits(['ctaClicked'])

const ctaClicked = () => {
  emit('ctaClicked', {
    type: props.ctaType,
    url: props.ctaUrl
  })
}
</script>
<style scoped>
.section_background {
  transform: rotate(180deg); 
}
.square-box{
  padding-bottom: 100%;
  background-position: center;
}
.rect-box{
  padding-bottom: 50%;
  background-position: top;
}
.standard-content-text :deep(ul), 
.standard-content-text :deep(ol){
  list-style: none;
  position: relative;
  margin-left: 0;
}
.standard-content-text :deep(ol){
  counter-reset: standard-content-counter;
}
.standard-content-text :deep(ul li), 
.standard-content-text :deep(ol li){
  position: relative;
  padding-top: 20px;
  padding-left: 34px;  /* width of checkmark is 18px and spacing is 16px */
}

.standard-content-text :deep(ol li){
  counter-increment: standard-content-counter;
  text-align: left;
}

.standard-content-text :deep(ul li)::before, 
.standard-content-text :deep(ol li)::before {
  position: absolute;
  left: 0;
  font-size: 18px;
}
.standard-content-text :deep(ul li)::before {
  content: "\e00c";
  font-family: majority-dsm;
}

.standard-content-text :deep(ol li)::before {
  content: counter(standard-content-counter) ". ";
}
.blendCard {
  color: black;
  mix-blend-mode: difference;
  filter: invert(1) grayscale(1);
}
.backgroundVideo {
    object-fit: cover;
    width: 100%;
    height: 100%;
}
</style>
